module.exports = __webpack_public_path__ + "static/media/checkbox_small_checked.90a805e2.svg";